import { MedplumClient } from "@medplum/core";
import { getAutocompleteSearchFunction } from "@medplum/health-gorilla-react";

import { MedplumSystems } from "@/fhir/enums/medplum";

/**
 * Builds the lab test search for the Health Gorilla autocomplete inputs. It lives apart from
 * `labs.ts` because `@medplum/health-gorilla-react` brings in `@medplum/react`, and bots import
 * `labs.ts`.
 *
 * @param medplum - the Medplum client that runs the autocomplete bot.
 * @returns the search function for the lab test input.
 */
export function getHealthGorillaAutocomplete(medplum: MedplumClient) {
  return getAutocompleteSearchFunction(medplum, {
    system: MedplumSystems.BotIdentifier,
    value: "health-gorilla-labs/autocomplete",
  });
}
